import React from "react";
import "./../styles/ReferencesCell.css";
import { IconButton, Link } from '@mui/material';
import { InfoOutlined, KeyboardArrowUp as KeyboardArrowUpIcon, KeyboardArrowDown as KeyboardArrowDownIcon } from "@mui/icons-material";
import SampleDetails from "./SearchWithProvider/SampleDetails";
import { Row } from "./SearchWithProvider/types";


type Props = {
    original: Row,
    state: any
    setState: (prev: object) => any
}

const ReferencesCell = ({ original, state, setState }: Props) => {
    const toggleOpen = () => setState((prev: any) => ({
        ...prev,
        open: !prev.open
    }));
    
    return (
        <div className="reference-cell-container">
            {!!original.subRows && (
                <IconButton
                    aria-label="expand row"
                    size="small"
                    onClick={toggleOpen}
                    sx={{
                        padding: 0,
                        height: 30,
                        width: 30
                    }}
                >
                    {state.open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                </IconButton>
            )}
            <SampleDetails
                sampleId={original['sample identifier']}
            >
              <Link href={`/samples/${original['sample identifier']}`} target="_blank" underline="none"> 
                <InfoOutlined fontSize="small" /> 
              </Link>
            </SampleDetails>
        </div>
    )
}

export default ReferencesCell;
